module.exports = __webpack_public_path__ + "static/img/promotion.d107f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion.png
// module id = 6xHy
// module chunks = 3